var map = {
	"./--logo.png": 614,
	"./-logo.png": 615,
	"./AMPL-logo.png": 616,
	"./AXIOMS-logo.png": 617,
	"./AXMATIC   -logo.png": 618,
	"./AXMATIC  -logo.png": 619,
	"./AXMATIC -logo.png": 620,
	"./AXMATIC-DMAGIC-LP-logo.png": 621,
	"./AXMATIC-DMAGIC-SLP-logo.png": 622,
	"./AXMATIC-DMAGIC-logo.png": 623,
	"./AXMATIC-logo.png": 624,
	"./BAT-logo.png": 625,
	"./BPT-logo.png": 626,
	"./BUSD-logo.png": 627,
	"./Balancer Pool-logo.png": 628,
	"./COMP-logo.png": 629,
	"./DAI-logo.png": 630,
	"./DMAGIC     -logo.png": 631,
	"./DMAGIC    -logo.png": 632,
	"./DMAGIC   -logo.png": 633,
	"./DMAGIC  -logo.png": 634,
	"./DMAGIC -logo.png": 635,
	"./DMAGIC-logo.png": 636,
	"./DRAX     -logo.png": 637,
	"./DRAX    -logo.png": 638,
	"./DRAX   -logo.png": 639,
	"./DRAX  -logo.png": 640,
	"./DRAX -logo.png": 641,
	"./DRAX-logo.png": 642,
	"./ETH-logo.png": 643,
	"./FTM-logo.png": 644,
	"./Governance-logo.png": 645,
	"./HBTC-logo.png": 646,
	"./HUSD-logo.png": 647,
	"./KNC-logo.png": 648,
	"./LEND-logo.png": 649,
	"./LINK-logo.png": 650,
	"./MAGIC-logo.png": 651,
	"./MATIC    -logo.png": 652,
	"./MATIC   -logo.png": 653,
	"./MATIC  -logo.png": 654,
	"./MATIC -logo.png": 655,
	"./MATIC-logo.png": 656,
	"./MEFI-logo.png": 657,
	"./MKR-logo.png": 658,
	"./NEWMBAT-logo.png": 659,
	"./NIGHTBANE    -logo.png": 660,
	"./NIGHTBANE   -logo.png": 661,
	"./NIGHTBANE  -logo.png": 662,
	"./NIGHTBANE -logo.png": 663,
	"./NIGHTBANE-logo.png": 664,
	"./REP-logo.png": 665,
	"./SAI-logo.png": 666,
	"./SNX-logo.png": 667,
	"./SUSD-logo.png": 668,
	"./TUSD-logo.png": 669,
	"./USDC-logo.png": 670,
	"./USDT-logo.png": 671,
	"./WETH-logo.png": 672,
	"./ZRX-logo.png": 673,
	"./aLINK-logo.png": 674,
	"./cUSDC-logo.png": 675,
	"./cUSDT-logo.png": 676,
	"./choose-logo.png": 677,
	"./dmagic1-logo.png": 678,
	"./undefined-logo.png": 679,
	"./wBTC-logo.png": 680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;